/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Body4(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Body4.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Body4.geometry}
        material={nodes.Body4.material}
        position={[0, 122.49, 0]}
      >
        <meshPhysicalMaterial
          color={colorArr[3]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Body4.glb')
